import React, { useState } from 'react';
import { FaTimes, FaUniversity, FaCreditCard } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import { modalVariants } from '../animations';
import EditIbanModal from './EditIbanModal';
import api from '../../../services/api';

const SettingsModal = ({ isOpen, onClose, currentUser, onUpdateUser }) => {
  const [isEditIbanOpen, setIsEditIbanOpen] = useState(false);

  const handleIbanSave = async (newIban) => {
    // Ici vous pouvez ajouter la logique pour sauvegarder l'IBAN
    // Par exemple, un appel API
    if (onUpdateUser) {
      await onUpdateUser({ iban: newIban });
    }
  };

  const handleCancelSubscription = async () => {
    if (!window.confirm('⚠️ Êtes-vous sûr de vouloir résilier votre abonnement Fideliz ?\n\nCette action annulera votre souscription et vous n\'aurez plus accès aux fonctionnalités premium.')) {
      return;
    }

    try {
      const token = localStorage.getItem('token');
      await api.post('/subscription/cancel', {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      alert('✅ Votre abonnement a été résilié avec succès.\n\nNous sommes désolés de vous voir partir. Merci d\'avoir utilisé Fideliz.');
      
      // Rafraîchir les données utilisateur
      if (onUpdateUser) {
        await onUpdateUser();
      }
      
      onClose();
    } catch (error) {
      console.error('Erreur lors de la résiliation:', error);
      alert('❌ Une erreur est survenue lors de la résiliation de votre abonnement.\n\nVeuillez réessayer ou contacter le support à contact@fideliz.fr');
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div {...modalVariants.overlay} className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <motion.div {...modalVariants.content} className="bg-white rounded-2xl w-full max-w-2xl max-h-[95vh] flex flex-col overflow-hidden">
        {/* Header */}
        <div className="px-8 py-6 border-b border-gray-200 flex items-center justify-between flex-shrink-0">
          <div>
            <h2 className="text-2xl font-semibold text-gray-900">Paramètres</h2>
            <p className="text-sm text-gray-500 mt-1">Gérer votre compte</p>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
          >
            <FaTimes className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-8 space-y-6">
          {/* Section IBAN */}
          <div className="bg-gray-50 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-fideliz-blue/10 rounded-lg flex items-center justify-center">
                <FaUniversity className="w-5 h-5 text-fideliz-blue" />
              </div>
              <div>
                <h3 className="text-base font-semibold text-gray-900">IBAN</h3>
                <p className="text-sm text-gray-500">Pour recevoir vos paiements</p>
              </div>
            </div>
            <button
              onClick={() => setIsEditIbanOpen(true)}
              className="w-full px-4 py-2.5 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium"
            >
              Modifier mon IBAN
            </button>
          </div>


          {/* Info boutique */}
          <div className="bg-fideliz-blue/5 rounded-xl p-6">
            <h3 className="text-sm font-semibold text-fideliz-blue mb-3">Informations boutique</h3>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">Email</span>
                <span className="font-medium text-gray-900">{currentUser?.email}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Téléphone</span>
                <span className="font-medium text-gray-900">{currentUser?.phone}</span>
              </div>
            </div>
          </div>
        </div>
          </motion.div>
        </motion.div>
      )}
      
      {/* Modal d'édition de l'IBAN */}
      <EditIbanModal
        isOpen={isEditIbanOpen}
        onClose={() => setIsEditIbanOpen(false)}
        currentUser={currentUser}
        onSave={handleIbanSave}
      />
    </AnimatePresence>
  );
};

export default SettingsModal;

